<mat-toolbar>
  <span><a [routerLink]="['/data/unit']" translate>UNITS</a>&nbsp;</span>
  <span> / {{item && item.name ? item.name : 'New'}}</span>
  <span class="toolbar-spacer"></span>
  @if (item && item.id) {
    <button mat-raised-button color="warn" (click)="onDeleteItemClick()">Delete unit</button>
  }
  <button mat-raised-button color="primary" (click)="saveItem()" class="ms-2">
    <span translate>SAVE</span>
  </button>
</mat-toolbar>

@if (item) {
  <div class="row my-3">
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label translate>NAME</mat-label>
        <input type="text" matInput [(ngModel)]="item.name" required>
      </mat-form-field>
    </div>
    @if (item.id) {
      <div class="col-md-4">
        <mat-form-field class="w-100">
          <mat-label>Módosította</mat-label>
          <input type="text" matInput [(ngModel)]="item.modifiedBy" disabled="disabled" readonly="readonly">
        </mat-form-field>
      </div>
    }
    @if (item.id) {
      <div class="col-md-4">
        <mat-form-field class="w-100">
          <mat-label>Módosítva</mat-label>
          <input type="text" matInput [(ngModel)]="item.modified" disabled="disabled" readonly="readonly">
        </mat-form-field>
      </div>
    }
  </div>
}
